var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_5024)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#6C757E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9501_5024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 26.5V41.5C31 43.987 28.987 46 26.5 46C24.013 46 22 43.987 22 41.5V26.5C22 24.013 24.013 22 26.5 22C28.987 22 31 24.013 31 26.5ZM46 26.5V41.5C46 43.987 43.987 46 41.5 46C39.013 46 37 43.987 37 41.5V26.5C37 24.013 39.013 22 41.5 22C43.987 22 46 24.013 46 26.5Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_5024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9501_5024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(22 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPause);
export default __webpack_public_path__ + "static/media/audio-pause.08517571869ad0fcb91e70f561efc594.svg";
export { ForwardRef as ReactComponent };